import { render } from "./AnimationBallAnimationChild.vue?vue&type=template&id=17ea7834&scoped=true"
const script = {}

import "./AnimationBallAnimationChild.vue?vue&type=style&index=0&id=17ea7834&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ea7834"]])

export default __exports__